module.exports = __webpack_public_path__ + "static/railwaystation-b32918b544acdf327cd6d70e9cbbba12.png";